import { AbstractAjaxLoader, AjaxLoaderOptions } from "./AbstractAjaxLoader.js";
import { registerLoader } from "./AbstractLoader.js";

export interface TextLoaderOptions extends AjaxLoaderOptions {

}

export class TextLoader extends AbstractAjaxLoader<string, TextLoaderOptions>{
    protected defaultOptions(): TextLoaderOptions {
        return {
            decoder: "text"
        }
    }
}

registerLoader("text", TextLoader);